import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const generateRemoteUrl = (
  searchQuery: string,
  selectedSubjects: number[],
  selectedOverseers: number[],
  noFutureMeeting: boolean,
  onlyActive: boolean,
  startDate?: string | null,
  endDate?: string | null,
  downloadUrl = false
) => {
  const filters = [];

  if (searchQuery) filters.push(`search=${searchQuery}`);
  if (noFutureMeeting) filters.push("without_future_meeting=true");
  if (onlyActive) filters.push("only_active=true");
  if (selectedSubjects.length) filters.push(`subject_ids=${selectedSubjects.join(",")}`);
  if (selectedOverseers.length) filters.push(`overseer_ids=${selectedOverseers.join(",")}`);

  if (startDate) filters.push(`dt_start=${new Date(startDate).toISOString()}`);

  if (endDate) {
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);
    filters.push(`dt_end=${end.toISOString()}`);
  }

  return `${downloadUrl ? "projects/download" : "projects"}${filters.length ? `?${filters.join("&")}` : ""}`;
};

export const fetchProjectSubjects = (setProjectSubjects: Function, language: string, setIsLoading: Function) => {
  setIsLoading(true);
  ApiService.get("projects/subjects?order_by=name&order=asc")
    .then((response) => setProjectSubjects(response.data.project_subjects))
    .catch((err) => {
      console.error("Error fetching project subject data:", err);
      alert(translate(language, "PAGES.PROJECTS.ALERT.ERROR.FETCH_PROJECT_SUBJECT"));
    })
    .finally(() => setIsLoading(false));
};

export const downloadProjectsCsv = (language: string, url: string, setDownloading: Function) => {
  setDownloading(true);

  ApiService.get(url)
    .then((resp) => {
      const link = document.createElement("a");
      const actualDate = new Date().toISOString().replace(/[:.]/g, "-").replace("T", "_").slice(0, 19);

      link.href = window.URL.createObjectURL(new Blob([resp.data]));
      link.setAttribute("download", `export-projects-${actualDate}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch((err) => {
      console.error("Failed to download project list", err);
      alert(translate(language, "PAGES.PROJECTS.ALERT.ERROR.DOWNLOADING_CSV"));
    })
    .finally(() => setDownloading(false));
};
